import { useParams } from "react-router-dom";
import { DashboardLayout } from "./_common/DashboardLayout";
import { useEffect, useState } from "react";
import { BoardcastForm } from "./components/BoardcastForm";
import { broadcastGetService, broadcastUpdateService } from "../utils/api";
import { notifyError, notifySuccess } from "../utils/notify";

export function BroadcastEdit() {

    const params = useParams();
    const { id } = params;

    // useState
    const [forwardGroup, setForwardGroup] = useState(null);

    const getForwardGroup = () => {
        broadcastGetService(id, (data) => {
            if (data.success) {
                setForwardGroup(data.group)
            } else {
                notifyError(data.message)
            }
        })
    }

    useEffect(() => {
        getForwardGroup();
    }, [id]);

    if (!forwardGroup) {
        return <DashboardLayout route="/broadcast/edit">
            <h1 className="text-4xl font-semibold">Edit Broadcast</h1>
            <div>Loading...</div>
        </DashboardLayout>
    }

    return (
        <DashboardLayout route="/broadcast">
            <h1 className="text-4xl font-semibold">Edit Broadcast</h1>

            <div className="mt-6">
                <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-1">
                        <BoardcastForm 
                            initialData={forwardGroup}
                            onSubmit={(data) => {
                                broadcastUpdateService({...forwardGroup, ...data}, (data) => {
                                    if (data.success) {
                                        notifySuccess(data.message)
                                        getForwardGroup();
                                    } else {
                                        notifyError(data.message)
                                    }
                                })
                            }} 
                        />
                    </div>
                </div>
            </div>
        </DashboardLayout>
    )
}